var exports = {
  "u": "xa15a2ab7--3f5290--section",
};

module.exports = exports;
